// extracted by mini-css-extract-plugin
export var modal = "_ih-0";